import { useInsightsV5 } from "../../hooks/useInsightsV5";

export default function NarrativaInsights() {
  const userId = (typeof window !== "undefined" && window.__USER_ID__) || "guest";
  const { data, loading } = useInsightsV5(userId);

  if (loading) {
    return (
      <div className="insights-panel">
        <h2 className="insights-title">Narrativa de tu evolución</h2>
        <p className="insights-subtitle">Generando narrativa con RAG…</p>
      </div>
    );
  }

  if (!data || data.status === "no_data") {
    return (
      <div className="insights-panel">
        <h2 className="insights-title">Narrativa de tu evolución</h2>
        <p className="insights-subtitle">
          {(data && data.narrative) || "No hay datos suficientes."}
        </p>
      </div>
    );
  }

  return (
    <div className="insights-panel">
      <h2 className="insights-title">Narrativa de tu evolución</h2>
      <p className="insights-subtitle">
        Resumen narrativo generado a partir de tu actividad y memoria RAG continua.
      </p>

      <div className="insights-card">
        <h3>Resumen narrativo</h3>
        <p style={{ marginTop: 6, lineHeight: 1.55, color: "#f3f4f6" }}>
          {data.narrative}
        </p>
      </div>

      <div className="insights-grid" style={{ marginTop: "16px" }}>
        <div className="insights-card">
          <h3>Interacciones totales</h3>
          <div className="insights-metric">{data.total_interactions}</div>
        </div>
        <div className="insights-card">
          <h3>Herramienta más usada</h3>
          <div className="insights-metric" style={{ fontSize: 22 }}>
            {data.most_used_tool}
          </div>
        </div>
        <div className="insights-card">
          <h3>Hora más activa</h3>
          <div className="insights-metric">{data.most_active_hour}:00</div>
        </div>
      </div>
    </div>
  );
}
